import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=285b673e"
import script from "./ContractDetail.vue?vue&type=script&lang=ts"
export * from "./ContractDetail.vue?vue&type=script&lang=ts"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&id=285b673e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports